import { Typography, cn, emptyFragment } from '@execonline-inc/execonline-ui';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { PropsWithChildren } from 'react';
import ReactHtmlParser from 'react-html-parser';

interface Props {
  name: Maybe<string>;
  description: Maybe<string>;
}

function ExperienceSection({ name, description, children }: PropsWithChildren<Props>) {
  return (
    <div
      data-testid="learning-collection-experience-section"
      data-intercom-target="learning-collection-preview-experience-section"
      className={cn('mx-auto flex flex-col px-0 py-10 xl:container')}
    >
      <div
        data-testid="learning-collection-experience-header"
        data-intercom-target="learning-collection-preview-experience-header"
        className="px-6 md:px-16"
      >
        {name
          .map((n) => (
            <div className="flex items-center justify-between">
              <Typography className="!p-0 tracking-normal text-black" variant="h5" as="h2">
                {n}
              </Typography>
            </div>
          ))
          .getOrElse(emptyFragment)}
        {description
          .map((d) => (
            <Typography
              className={cn(
                'mt-4 !text-sm leading-normal text-black sm:!text-lg',
                '[&_p]:mb-6 [&_p]:last:mb-0',
                '[&_ul]:mb-4 [&_ul]:list-disc [&_ul]:pl-6',
                '[&_li]:mb-2 [&_li]:last:mb-0',
                '[&_strong]:font-semibold',
                '[&_em]:italic',
              )}
              variant="bodyLarge"
              as="div"
            >
              {ReactHtmlParser(d)}
            </Typography>
          ))
          .getOrElse(emptyFragment)}
      </div>
      <div
        data-testid="learning-collection-experience-body"
        data-intercom-target="learning-collection-preview-experience-body"
        className="px-6 md:px-16"
      >
        {children}
      </div>
    </div>
  );
}

export default observer(ExperienceSection);
